import React from "react";

import { Button } from "components";
import s from "components/UI/Button/FormButton.module.scss";

import UserDetailsDashboard from "pages/usuarios/UserDetailsDashboard";

export default function DetailModal({
    merchantServicioUsuarioId, closeModal, service
}) {
    return (
        <>
            <UserDetailsDashboard merchantServicioUsuarioId={merchantServicioUsuarioId} service={service} />
            <div className={"closeButtonContainer"}>
                <Button
                    className={s.defaultBtn}
                    onClick={closeModal}
                >
                    Cerrar
                </Button>
            </div>

        </>
    );
}
